import { take, put } from 'redux-saga/effects'
import { replace } from 'connected-react-router'

import { DUPLICATE_REFERENCE_PARAM } from 'actions/referenceParameter'

const forwardingDictionary = {
  [DUPLICATE_REFERENCE_PARAM]: duplicateRP,
}

export default function* watchForPageForwardingActions() {
  while (true) {
    const action = yield take(Object.keys(forwardingDictionary))
    yield put(forwardingDictionary[action.type](action))
  }
}

function duplicateRP({ data }) {
  const { result: uri } = data
  // normalizr schema returns the uri and calls it referenceParameter
  return replace({
    pathname: uri,
    search: '?editing=true',
  })
}
